import { Button, InputLabel } from '@mui/material';
import { FormContainer, SubmitWrapper } from "../Hospitals/HospitalStyle"
import { NurseFormSchema, updateNurseFormSchema } from '../../schemas/NurseFormSchema'
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { facilityTypeOptions, genderOptions, regions } from './formOptions';

import CustomApiLoader from '../../components/CustomApiLoader/CustomApiLoader';
import CustomToast from '../../components/Toast/CustomToast';
import DatePickerController from '../../components/CustomDatepicker/CustomDatePicker';
import { ENDPOINT } from '../../services/endPoints';
import InputController from '../../components/InputController/InputController';
import SelectController from '../../components/SelectController/SelectController';
import { useForm } from 'react-hook-form';
import useMasterApi from '../../services/useMasterApi';
import { useNavigate } from 'react-router-dom';
import useToast from '../../hooks/useToast';
import { useUpdateForm } from '../../context/UpdateFormProvider';
import { yupResolver } from '@hookform/resolvers/yup';

const AddNurses = () => {
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  const { loading: addLoading, data: addResponse, error, post } = useMasterApi()
  const { loading:updateLoading, data: updateResponse, error:updateError, put } = useMasterApi()

  const navigate = useNavigate()
  const {updateFormValues} = useUpdateForm()

  let {
    nurses_first_name= "",
    nurses_last_name= "",
    nurses_national_id= "",
    nurses_sex= "",
    nurses_dob= "",
    facility_name= "",
    facility_type= "",
    facility_code= "",
    city= "",
    nurses_role= "",
    nurses_email_id= "",
    password= "",
    nurses_contact= "",
    nurses_region= "",
    section = "",
  } = updateFormValues || {};
  const isUpdate = !!Object.keys(updateFormValues || {}).length

  const { handleSubmit, reset, watch, control, formState: { errors, isValid, isDirty } } = useForm({
    resolver: yupResolver( isUpdate? updateNurseFormSchema :  NurseFormSchema),
    mode: "onChange",
    defaultValues: {
      nurses_first_name: isUpdate ? nurses_first_name : "",
      nurses_last_name: isUpdate ? nurses_last_name : "",
      nurses_national_id: isUpdate ? nurses_national_id : "",
      nurses_sex: isUpdate ? nurses_sex : "",
      nurses_dob: isUpdate ? nurses_dob : "",
      facility_name: isUpdate ? facility_name : "",
      facility_type: isUpdate? facility_type : "",
      facility_code: isUpdate ? facility_code : "",
      city: isUpdate ? city : "",
      nurses_role: isUpdate ? nurses_role : "",
      nurses_email_id: isUpdate ? nurses_email_id : "",
      password: isUpdate ? "**********" : "",
      confirmPassword: isUpdate ? "**********" : "",
      nurses_contact: isUpdate ? nurses_contact : "",
      nurses_region: isUpdate ? nurses_region : "",
      section: isUpdate ? section : "",
    }
  });

    const onSubmit = async (data) => {
    if (isUpdate) {
      const formData = { ...data };
      delete formData.confirmPassword;
        await put(`${ENDPOINT.NURSE}/${updateFormValues.nurses_id}`, formData);
  } else {
          const formData = { ...data };
        delete formData.confirmPassword;
       await post(ENDPOINT.NURSE, formData)
  }
  reset();

  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };
  
    const handleLoad = () => {
      const navigationEntry = window.performance.getEntriesByType("navigation")[0];
      if (navigationEntry && navigationEntry.type === 'reload') {
        navigate('/nurses-list'); 
      }
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);
  
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  useEffect(()=>{
    if(addResponse.success){
      showToast("success", "Nurse Added Successfully")
      setTimeout(()=>navigate("/nurses-list", {replace: true}), 1500)
    } 
    if(error){
      showToast("error", error.data.error)
      setTimeout(()=>navigate("/nurses-list", {replace: true}), 1500)
    }
    if(updateResponse.success){
      showToast("success", "Hospital Updated Successfully")
      setTimeout(()=>navigate("/nurses-list", {replace: true}), 1500)
    }
    if(updateError){
      showToast("error", updateError.data.error)
    }
},[addResponse, error, updateResponse, updateError])


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputLabel sx={{ fontSize: "1.5rem" }}>Add Nurse</InputLabel>
      <FormContainer>
        <InputController
          name="nurses_first_name"
          label="First Name"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <InputController
          name="nurses_last_name"
          label="Last Name"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <InputController
          name="nurses_national_id"
          label="National ID"
          isNumberField={true}
          control={control}
          isLoading={addLoading}
          errors={errors} />

          <SelectController
          name="nurses_sex"
          label="Gender"
          control={control}
          options={genderOptions}
          isLoading={addLoading}
          errors={errors}
        />

          <DatePickerController
          name="nurses_dob"
          label="Date of Birth"
          control={control}
          isLoading={addLoading}
          errors={errors}
          readOnly={isUpdate? true : false}
          />

        <InputController
          name="facility_name"
          label="Facility Name"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <SelectController
          name="facility_type"
          label="Facility Type"
          control={control}
          options={facilityTypeOptions}
          isLoading={addLoading}
          errors={errors}
        />

        <InputController
          name="facility_code"
          label="Facility Code"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <InputController
          name="city"
          label="City"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <InputController
          name="nurses_role"
          label="Nurse Role"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <InputController
          name="nurses_email_id"
          label="Email ID"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <InputController
          name="section"
          label="Section"
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <InputController
          name="nurses_contact"
          label="Contact Number"
          isNumberField={true}
          control={control}
          isLoading={addLoading}
          errors={errors} />

        <SelectController
          name="nurses_region"
          label="Region"
          control={control}
          options={regions}
          isLoading={addLoading || updateLoading}
          errors={errors}
        />

          <InputController
          name="password"
          label="Password"
          control={control}
          isLoading={addLoading || !!password}
          errors={errors} 
          />
          <InputController
          name="confirmPassword"
          label="Confirm Password"
          control={control}
          isLoading={addLoading || !!password}
          errors={errors} 
          isGrow
          isCustomError
          />
         

      </FormContainer>
      <SubmitWrapper>
      <Button type="submit" variant="contained"
                  sx={{minWidth:"180px"}}
                  disabled={!isValid || (addLoading || updateLoading)}>{addLoading || updateLoading ? <CustomApiLoader/> : isUpdate ? "Update" : "Add" }</Button>
                   <Button type="button" variant="contained" onClick={()=>reset()}
                   sx={{minWidth:"180px"}} disabled={addLoading || updateLoading || isUpdate}>Reset</Button>
      </SubmitWrapper>
      {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </form>
  )
}

export default AddNurses